// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content .el-form-item{margin-top:20px}.content .el-form-item__content{margin-left:0!important;font-size:16px}.content .el-input__inner{border-radius:0;width:486px;height:40px;background:#fcfcfc}.content .el-input{width:486px;height:40px}", ""]);
// Exports
module.exports = exports;
